import type {AppThunk} from '../../../../actions/types'
import type {LoadedEndpoints} from '../../../../routes/loadEndpoint'
import type {ProjectId} from '../../../../types'

import {preloadProjectInvestigationsTabTree} from './ProjectInvestigationsTree/ProjectInvestigationsTabTree.preload'

export const preloadProjectInvestigationsTab =
  ({
    projectId,
    isTestsTreeExpanded = true,
  }: {
    projectId: ProjectId
    isTestsTreeExpanded?: boolean
  }): AppThunk<LoadedEndpoints> =>
  dispatch =>
    isTestsTreeExpanded ? [...dispatch(preloadProjectInvestigationsTabTree(projectId))] : []
